import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import BuyerPulseCheckCard from '../BuyerPulseCheckCard';
import LeadContext from '../../providers/Lead/Lead.context';
import AfterConfirmationActions from '../BuyerActions/AfterConfirmationActions';
import { LEAD_STAGES } from 'models/Lead';
import { USER_ACTIONS } from '../BuyerActions';

import './NextStep.styles.scss';

type NextStepProps = {
  className?: string;
};

const NextStep: React.FC<NextStepProps> = (props) => {
  const { className } = props;

  const classes = classNames('next-step', className);

  const {
    buyerStep,
    withdrawnInterest,
    confirmedInterest,
    pulseCheckActive,
    isUndoAvailableForCheckPulse,
    isConfirmingInterestInProgress,
  } = useContext(LeadContext);

  const isAcceptStage = useMemo(
    () => buyerStep === LEAD_STAGES.ACCEPT,
    [buyerStep],
  );

  const BuyerActions = useMemo(
    () =>
      withdrawnInterest ||
      (isAcceptStage &&
        !confirmedInterest &&
        (pulseCheckActive || isConfirmingInterestInProgress))
        ? null
        : isAcceptStage && confirmedInterest
        ? AfterConfirmationActions
        : buyerStep && USER_ACTIONS[buyerStep],
    [
      buyerStep,
      confirmedInterest,
      isAcceptStage,
      isConfirmingInterestInProgress,
      pulseCheckActive,
      withdrawnInterest,
    ],
  );

  const shouldRenderSoftSignal = useMemo(
    () =>
      pulseCheckActive &&
      !isUndoAvailableForCheckPulse &&
      !isConfirmingInterestInProgress,
    [
      isConfirmingInterestInProgress,
      isUndoAvailableForCheckPulse,
      pulseCheckActive,
    ],
  );

  if (!BuyerActions && !shouldRenderSoftSignal) return null;

  return (
    <div className={classes}>
      {shouldRenderSoftSignal && <BuyerPulseCheckCard />}

      {shouldRenderSoftSignal && BuyerActions && (
        <span className="resolve-separator" />
      )}

      {BuyerActions && <BuyerActions />}
    </div>
  );
};

export default NextStep;
